import axios from 'axios';
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry';

import { GOOGLE_ID_TOKEN_STORAGE_KEY } from '@/components/auth/AuthContext';

const apiBaseUrl = () => {
  if (import.meta.env.DEV || import.meta.env.VITEST) {
    // vite config proxy handles APP_BACKEND_URL
    return '';
  }

  return import.meta.env.VITE_APP_BACKEND_URL;
};

const api = axios.create({
  baseURL: apiBaseUrl()
});
axiosRetry(api, {
  retries: 3,
  shouldResetTimeout: true,
  retryCondition: error => isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED',
  retryDelay(retryCount) {
    return retryCount * 1000;
  }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem(GOOGLE_ID_TOKEN_STORAGE_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-App-Version'] = import.meta.env.VITE_APP_VERSION;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    // If a 401 error is encountered, remove the token and redirect to /sign-in
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(GOOGLE_ID_TOKEN_STORAGE_KEY);
      window.location.href = '/sign-in';
    }

    return Promise.reject(error);
  }
);

export default api;
